<template>
  <div>
    <view-options elementId="Youtube" />
    <div class="youtube-wrapper" id="Youtube">
      <div class="lds-ellipsis" v-if="loadingData">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-if="
            isSkipabbleAvailable ||
              (!isBumperAvailable &&
                !isDiscoveryAvailable &&
                !isNonSkipAvailable &&
                !isVideoforActionAvailable)
          "
          label="Skipabble"
          name="2"
        >
          <div class="product-view youtube-product skippable">
            <div>
              <section class="widget widget-goals">
                <h3 class="widget-title">
                  ¿Qué logró su publicidad en YouTube?
                </h3>
                <div class="cards-wrapper">
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="eye" />
                      </div>
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(
                            skippable.productData.totalImpressions
                          ) || 0
                        }}
                      </h1>
                      <p>Cantidad de veces que su anuncio fue mostrado</p>
                    </div>
                  </card>
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="play" />
                      </div>
                      <h4 class="card-title">Visualizaciones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(skippable.productData.totalViews) || 0
                        }}
                      </h1>
                      <p>Cantidad de reproducciones totales</p>
                    </div>
                  </card>
                </div>
              </section>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">
                        Total de impresiones y visualizaciones
                      </h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="
                        skippable.productData.totalImpressions || 0
                      "
                      :impressions="Product.impressions || []"
                      :clicks="Product.views || []"
                      :imp="skippable.impressionsChartOptions"
                      :labelType="'Visualizaciones'"
                    ></impressions>
                  </div>
                </card>
              </section>
            </div>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/youtube-phone.png" alt />
              </section>
            </mq-layout>

            <section
              class="widget campaign-widget"
              v-if="campaignSkippableData.length !== 0"
            >
              <h3 class="widget-title">Campañas</h3>
              <card>
                <table class="table">
                  <thead>
                    <th>Campaña</th>
                    <th>Impresiones</th>
                    <th>Views</th>
                    <th>CTR</th>
                    <th>CPM</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(campaignSkippableData,
                      index) in campaignSkippableData"
                      :key="index"
                    >
                      <td>{{ campaignSkippableData.name }}</td>
                      <td>
                        {{
                          Number(
                            campaignSkippableData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(campaignSkippableData.views).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{ Number(campaignSkippableData.ctr).toPrecision(2) }}%
                      </td>
                      <td>${{ Number(campaignSkippableData.cpm) }}</td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          skippable.TotalCampains.Impresiones.toLocaleString()
                        }}
                      </th>
                      <th>
                        {{ skippable.TotalCampains.Views.toLocaleString() }}
                      </th>
                      <th>{{ skippable.TotalCampains.Ctr }}%</th>
                      <th>${{ skippable.TotalCampains.Cpm }}</th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>

            <section
              v-if="skippable.AllConversionActions.length"
              class="widget campaign-widget"
            >
              <h3 class="widget-title">Resumen de Conversions</h3>
              <!-- <div > -->
              <!-- <conversion-table v-for="(conversionAction, index) in ConversionActions" :key="index"  :conversionData="conversionAction"/> -->
              <conversion-table
                :conversionArray="skippable.AllConversionActions"
              />
              <!-- </div> -->
            </section>

            <section
              class="widget keyword-widget"
              v-if="skippableKeywordData.length"
            >
              <h3 class="widget-title">
                Keywords que mejor le ayudaron a aparecer en YouTube
              </h3>
              <card>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Keywords</th>
                      <th>Impresiones</th>
                      <th>Visualizaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(skippableKeywordData,
                      index) in skippableKeywordData"
                      :key="index"
                    >
                      <td>{{ skippableKeywordData.keyword }}</td>
                      <td>
                        {{
                          Number(
                            skippableKeywordData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(skippableKeywordData.views).toLocaleString()
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          Number(
                            skippableKeywordTotal.totalImpressions
                          ).toLocaleString()
                        }}
                      </th>
                      <th>
                        {{
                          Number(
                            skippableKeywordTotal.totalViews
                          ).toLocaleString()
                        }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>
            <div class="widget-area audience-report two-column">
              <section
                class="widget"
                v-if="
                  skippable.audienceInteractionSeries &&
                    skippable.audienceInteractionSeries.length > 0
                "
              >
                <h3 class="widget-title">Interacción de sus audiencias</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="skippable.audienceInteractionChartOptions"
                    :series="skippable.audienceInteractionSeries"
                  />
                </card>
              </section>
              <section
                class="widget"
                v-if="
                  skippable.interestTopicsSeries &&
                    skippable.interestTopicsSeries.length > 0
                "
              >
                <h3 class="widget-title">Interés en sus temas</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="skippable.interestTopicsChartOptions"
                    :series="skippable.interestTopicsSeries"
                  />
                </card>
              </section>
            </div>
            <p style="font-style: italic;">
              Se muestran los resultados de mayor volumen con un límite de 5
              elementos
            </p>

            <div class="widget-area demographic-data">
              <h3 class="widget-title">
                Datos demográficos sobre sus usuarios
              </h3>
              <section class="widget">
                <h5 class="widget-title">Género</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="skippable.genderChartOptions.xaxis.categories"
                    :series="skippable.genderSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Edad</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="skippable.ageChartOptions.xaxis.categories"
                    :series="skippable.ageSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Dispositivos</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="skippable.devicesChartOptions.xaxis.categories"
                    :series="skippable.devicesSeries[0].data"
                    :bar="false"
                  />
                </card>
              </section>
            </div>
            <h3 class="widget-title">
              Este es el desempeño de sus anuncios en YouTube
            </h3>
            <div class="widget-area two-column">
              <div class="widget ad-views">
                <div class="cards-wrapper">
                  <card class="ad-listing">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      indicator-position="none"
                      class="carousel-youtube"
                    >
                      <el-carousel-item
                        v-for="(skippableAd, index) in skippableAds"
                        :key="index"
                      >
                        <div class="youtube-header">
                          <img src="@/assets/images/youtube-logo.svg" alt />
                          <div class="header-buttons">
                            <font-awesome-icon icon="search" />
                            <!-- <font-awesome-icon icon="ellipsis-v" /> -->
                          </div>
                        </div>
                        <div
                          class="youtube-viewport"
                          v-if="skippableAd.videoURL"
                        >
                          <iframe
                            width="100%"
                            height="100%"
                            :src="skippableAd.videoURL"
                            frameborder="0"
                            scrolling="no"
                          ></iframe>
                        </div>
                        <div class="ad-data-copy">
                          <div class="data" v-if="skippableAd.impressions">
                            <h5>
                              {{
                                Number(skippableAd.impressions).toLocaleString()
                              }}
                            </h5>
                            <p>Impresiones</p>
                          </div>
                          <div class="data" v-if="skippableAd.views">
                            <h5>
                              {{ Number(skippableAd.views).toLocaleString() }}
                            </h5>
                            <p>Visualizaciones</p>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="isBumperAvailable" label="Bumper" name="1">
          <div class="product-view youtube-product bumper">
            <div>
              <section class="widget widget-goals">
                <h3 class="widget-title">
                  ¿Qué logró su publicidad en YouTube?
                </h3>
                <div class="cards-wrapper">
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="eye" />
                      </div>
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(bumper.productData.totalImpressions) || 0
                        }}
                      </h1>
                      <p>Cantidad de veces que su anuncio fue mostrado</p>
                    </div>
                  </card>
                </div>
              </section>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">Total de impresiones</h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="
                        bumper.productData.totalImpressions || 0
                      "
                      :impressions="ProductBumper.impressions || []"
                      :clicks="[] || []"
                      :imp="bumper.impressionsChartOptions"
                      :labelType="''"
                    ></impressions>
                  </div>
                </card>
              </section>
            </div>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/youtube-phone.png" alt />
              </section>
            </mq-layout>

            <section
              class="widget campaign-widget"
              v-if="campaignBumperData.length !== 0"
            >
              <h3 class="widget-title">Campañas</h3>
              <card>
                <table class="table">
                  <thead>
                    <th>Campaña</th>
                    <th>Impresiones</th>
                    <th>Clicks</th>
                    <th>CTR</th>
                    <th>CPM</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(campaignBumperData, index) in campaignBumperData"
                      :key="index"
                    >
                      <td>{{ campaignBumperData.name }}</td>
                      <td>
                        {{
                          Number(
                            campaignBumperData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{ Number(campaignBumperData.clicks).toLocaleString() }}
                      </td>
                      <td>{{ Number(campaignBumperData.ctr) }}%</td>
                      <td>${{ Number(campaignBumperData.cpm) }}</td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{ bumper.TotalCampains.Impresiones.toLocaleString() }}
                      </th>
                      <th>
                        {{ bumper.TotalCampains.Clicks.toLocaleString() }}
                      </th>
                      <th>{{ bumper.TotalCampains.Ctr }}%</th>
                      <th>${{ bumper.TotalCampains.Cpm }}</th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>

            <section
              v-if="bumper.AllConversionActions.length"
              class="widget campaign-widget"
            >
              <h3 class="widget-title">Resumen de Conversions</h3>
              <conversion-table
                :conversionArray="bumper.AllConversionActions"
              />
            </section>

            <section
              class="widget keyword-widget"
              v-if="bumperKeywordData.length"
            >
              <h3 class="widget-title">
                Keywords que mejor le ayudaron a aparecer en YouTube
              </h3>
              <card>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Keywords</th>
                      <th>Impresiones</th>
                      <!-- <th>Visualizaciones</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(bumperKeywordData, index) in bumperKeywordData"
                      :key="index"
                    >
                      <td>{{ bumperKeywordData.keyword }}</td>
                      <td>
                        {{
                          Number(bumperKeywordData.impressions).toLocaleString()
                        }}
                      </td>
                      <!-- <td>
                        {{ Number(bumperKeywordData.views).toLocaleString() }}
                      </td> -->
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          Number(
                            bumperKeywordTotal.totalImpressions
                          ).toLocaleString()
                        }}
                      </th>
                      <!-- <th>
                        {{
                          Number(bumperKeywordTotal.totalViews).toLocaleString()
                        }}
                      </th> -->
                    </tr>
                  </thead>
                </table>
              </card>
            </section>
            <div class="widget-area audience-report two-column">
              <section
                class="widget"
                v-if="
                  bumper.audienceInteractionSeries &&
                    bumper.audienceInteractionSeries.length > 0
                "
              >
                <h3 class="widget-title">Interacción de sus audiencias</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="bumper.audienceInteractionChartOptions"
                    :series="bumper.audienceInteractionSeries"
                  />
                </card>
              </section>
              <section
                class="widget"
                v-if="
                  bumper.interestTopicsSeries &&
                    bumper.interestTopicsSeries.length > 0
                "
              >
                <h3 class="widget-title">Interés en sus temas</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="bumper.interestTopicsChartOptions"
                    :series="bumper.interestTopicsSeries"
                  />
                </card>
              </section>
            </div>
            <p style="font-style: italic;">
              Se muestran los resultados de mayor volumen con un límite de 5
              elementos
            </p>

            <div class="widget-area demographic-data">
              <h3 class="widget-title">
                Datos demográficos sobre sus usuarios
              </h3>
              <section class="widget">
                <h5 class="widget-title">Género</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="bumper.genderChartOptions.xaxis.categories"
                    :series="bumper.genderSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Edad</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="bumper.ageChartOptions.xaxis.categories"
                    :series="bumper.ageSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Dispositivos</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="bumper.devicesChartOptions.xaxis.categories"
                    :series="bumper.devicesSeries[0].data"
                    :bar="false"
                  />
                </card>
              </section>
            </div>
            <h3 class="widget-title">
              Este es el desempeño de sus anuncios en YouTube
            </h3>
            <div class="widget-area two-column">
              <div class="widget ad-views">
                <div class="cards-wrapper">
                  <card class="ad-listing">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      indicator-position="none"
                      class="carousel-youtube"
                    >
                      <el-carousel-item
                        v-for="(bumperAd, index) in bumperAds"
                        :key="index"
                      >
                        <div class="youtube-header">
                          <img src="@/assets/images/youtube-logo.svg" alt />
                          <div class="header-buttons">
                            <font-awesome-icon icon="search" />
                            <!-- <font-awesome-icon icon="ellipsis-v" /> -->
                          </div>
                        </div>
                        <div class="youtube-viewport" v-if="bumperAd.videoURL">
                          <iframe
                            width="100%"
                            height="100%"
                            :src="bumperAd.videoURL"
                            frameborder="0"
                            scrolling="no"
                          ></iframe>
                        </div>
                        <div class="ad-data-copy">
                          <div class="data" v-if="bumperAd.impressions">
                            <h5>
                              {{
                                Number(bumperAd.impressions).toLocaleString()
                              }}
                            </h5>
                            <p>Impresiones</p>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!--Delivery--->
        <el-tab-pane
          v-if="isDiscoveryAvailable"
          label="Video Discovery"
          name="3"
        >
          <div class="product-view youtube-product discovery">
            <div>
              <section class="widget widget-goals">
                <h3 class="widget-title">
                  ¿Qué logró su publicidad en YouTube?
                </h3>
                <div class="cards-wrapper">
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="eye" />
                      </div>
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(
                            discovery.productData.totalImpressions
                          ) || 0
                        }}
                      </h1>
                      <p>Cantidad de veces que su anuncio fue mostrado</p>
                    </div>
                  </card>
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="play" />
                      </div>
                      <h4 class="card-title">Visualizaciones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(discovery.productData.totalViews) || 0
                        }}
                      </h1>
                      <p>Cantidad de reproducciones totales</p>
                    </div>
                  </card>
                </div>
              </section>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">
                        Total de impresiones y visualizaciones
                      </h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="
                        discovery.productData.totalImpressions || 0
                      "
                      :impressions="ProductDiscovery.impressions || []"
                      :clicks="ProductDiscovery.views || []"
                      :imp="discovery.impressionsChartOptions"
                      :labelType="'Visualizaciones'"
                    ></impressions>
                  </div>
                </card>
              </section>
            </div>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/youtube-phone.png" alt />
              </section>
            </mq-layout>

            <section
              class="widget campaign-widget"
              v-if="campaignDiscoveryData.length !== 0"
            >
              <h3 class="widget-title">Campañas</h3>
              <card>
                <table class="table">
                  <thead>
                    <th>Campaña</th>
                    <th>Impresiones</th>
                    <th>Views</th>
                    <th>VTR</th>
                    <th>CPV</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(campaignDiscoveryData,
                      index) in campaignDiscoveryData"
                      :key="index"
                    >
                      <td>{{ campaignDiscoveryData.name }}</td>
                      <td>
                        {{
                          Number(
                            campaignDiscoveryData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(campaignDiscoveryData.views).toLocaleString()
                        }}
                      </td>
                      <td>{{ campaignDiscoveryData.vtr }}%</td>
                      <td>
                        ${{
                          Number(campaignDiscoveryData.cpv).toLocaleString()
                        }}
                      </td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          discovery.TotalCampains.Impresiones.toLocaleString()
                        }}
                      </th>
                      <th>
                        {{ discovery.TotalCampains.Views.toLocaleString() }}
                      </th>
                      <th>{{ discovery.TotalCampains.Vtr }}%</th>
                      <th>
                        ${{ discovery.TotalCampains.Cpv.toLocaleString() }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>

            <section
              v-if="discovery.AllConversionActions.length"
              class="widget campaign-widget"
            >
              <h3 class="widget-title">Resumen de Conversions</h3>
              <conversion-table
                :conversionArray="discovery.AllConversionActions"
              />
            </section>

            <section
              class="widget keyword-widget"
              v-if="discoveryKeywordData.length"
            >
              <h3 class="widget-title">
                Keywords que mejor le ayudaron a aparecer en YouTube
              </h3>
              <card>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Keywords</th>
                      <th>Impresiones</th>
                      <!-- <th>Visualizaciones</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(discoveryKeywordData,
                      index) in discoveryKeywordData"
                      :key="index"
                    >
                      <td>{{ discoveryKeywordData.keyword }}</td>
                      <td>
                        {{
                          Number(
                            discoveryKeywordData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <!-- <td>
                        {{ Number(bumperKeywordData.views).toLocaleString() }}
                      </td> -->
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          Number(
                            discoveryKeywordTotal.totalImpressions
                          ).toLocaleString()
                        }}
                      </th>
                      <!-- <th>
                        {{
                          Number(bumperKeywordTotal.totalViews).toLocaleString()
                        }}
                      </th> -->
                    </tr>
                  </thead>
                </table>
              </card>
            </section>
            <div class="widget-area audience-report two-column">
              <section
                class="widget"
                v-if="
                  discovery.audienceInteractionSeries &&
                    discovery.audienceInteractionSeries.length > 0
                "
              >
                <h3 class="widget-title">Interacción de sus audiencias</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="discovery.audienceInteractionChartOptions"
                    :series="discovery.audienceInteractionSeries"
                  />
                </card>
              </section>
              <section
                class="widget"
                v-if="
                  discovery.interestTopicsSeries &&
                    discovery.interestTopicsSeries.length > 0
                "
              >
                <h3 class="widget-title">Interés en sus temas</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="discovery.interestTopicsChartOptions"
                    :series="discovery.interestTopicsSeries"
                  />
                </card>
              </section>
            </div>
            <p style="font-style: italic;">
              Se muestran los resultados de mayor volumen con un límite de 5
              elementos
            </p>

            <div class="widget-area demographic-data">
              <h3 class="widget-title">
                Datos demográficos sobre sus usuarios
              </h3>
              <section class="widget">
                <h5 class="widget-title">Género</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="discovery.genderChartOptions.xaxis.categories"
                    :series="discovery.genderSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Edad</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="discovery.ageChartOptions.xaxis.categories"
                    :series="discovery.ageSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Dispositivos</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="discovery.devicesChartOptions.xaxis.categories"
                    :series="discovery.devicesSeries[0].data"
                    :bar="false"
                  />
                </card>
              </section>
            </div>
            <h3 class="widget-title">
              Este es el desempeño de sus anuncios en YouTube
            </h3>
            <div class="widget-area two-column">
              <div class="widget ad-views">
                <div class="cards-wrapper">
                  <card class="ad-listing">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      indicator-position="none"
                      class="carousel-youtube"
                    >
                      <el-carousel-item
                        v-for="(discoveryAd, index) in discoveryAds"
                        :key="index"
                      >
                        <div class="youtube-header">
                          <img src="@/assets/images/youtube-logo.svg" alt />
                          <div class="header-buttons">
                            <font-awesome-icon icon="search" />
                            <!-- <font-awesome-icon icon="ellipsis-v" /> -->
                          </div>
                        </div>
                        <div
                          class="youtube-viewport"
                          v-if="discoveryAd.videoURL"
                        >
                          <iframe
                            width="100%"
                            height="100%"
                            :src="discoveryAd.videoURL"
                            frameborder="0"
                            scrolling="no"
                          ></iframe>
                        </div>
                        <div class="ad-data-copy">
                          <div class="data" v-if="discoveryAd.impressions">
                            <h5>
                              {{
                                Number(discoveryAd.impressions).toLocaleString()
                              }}
                            </h5>
                            <p>Impresiones</p>
                          </div>
                          <div class="data" v-if="discoveryAd.views">
                            <h5>
                              {{ Number(discoveryAd.views).toLocaleString() }}
                            </h5>
                            <p>Visualizaciones</p>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!--NonSkipp--->
        <el-tab-pane v-if="isNonSkipAvailable" label="Non Skip" name="4">
          <div class="product-view youtube-product nonSkipp">
            <div>
              <section class="widget widget-goals">
                <h3 class="widget-title">
                  ¿Qué logró su publicidad en YouTube?
                </h3>
                <div class="cards-wrapper one-column-card">
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="eye" />
                      </div>
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(nonskip.productData.totalImpressions) ||
                            0
                        }}
                      </h1>
                      <p>Cantidad de veces que su anuncio fue mostrado</p>
                    </div>
                  </card>
                </div>
              </section>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">
                        Total de impresiones y visualizaciones
                      </h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="ProductNonSkip.totalImpressions || 0"
                      :impressions="ProductNonSkip.impressions || []"
                      :clicks="[] || []"
                      :imp="nonskip.impressionsChartOptions"
                      :labelType="''"
                    ></impressions>
                  </div>
                </card>
              </section>
            </div>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/youtube-phone.png" alt />
              </section>
            </mq-layout>
            <section
              class="widget campaign-widget"
              v-if="campaignNonSkippableData.length !== 0"
            >
              <h3 class="widget-title">Campañas</h3>
              <card>
                <table class="table">
                  <thead>
                    <th>Campaña</th>
                    <th>Impresiones</th>
                    <th>Clicks</th>
                    <th>CTR</th>
                    <th>CPM</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(campaignNonSkippableData,
                      index) in campaignNonSkippableData"
                      :key="index"
                    >
                      <td>{{ campaignNonSkippableData.name }}</td>
                      <td>
                        {{
                          Number(
                            campaignNonSkippableData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(
                            campaignNonSkippableData.clicks
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{ Number(campaignNonSkippableData.ctr).toFixed(2) }}%
                      </td>
                      <td>
                        ${{ Number(campaignNonSkippableData.cpm).toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{ nonskip.TotalCampains.Impresiones.toLocaleString() }}
                      </th>
                      <th>
                        {{ nonskip.TotalCampains.Clicks.toLocaleString() }}
                      </th>
                      <th>{{ nonskip.TotalCampains.Ctr }}%</th>
                      <th>${{ nonskip.TotalCampains.Cpm }}</th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>

            <section
              v-if="nonskip.AllConversionActions.length"
              class="widget campaign-widget"
            >
              <h3 class="widget-title">Resumen de Conversions</h3>
              <conversion-table
                :conversionArray="nonskip.AllConversionActions"
              />
            </section>

            <section
              class="widget keyword-widget"
              v-if="nonskipKeywordData.length"
            >
              <h3 class="widget-title">
                Keywords que mejor le ayudaron a aparecer en YouTube
              </h3>
              <card>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Keywords</th>
                      <th>Impresiones</th>
                      <!-- <th>Visualizaciones</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(nonskipKeywordData, index) in nonskipKeywordData"
                      :key="index"
                    >
                      <td>{{ nonskipKeywordData.keyword }}</td>
                      <td>
                        {{
                          Number(
                            nonskipKeywordData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <!-- <td>
                        {{ Number(bumperKeywordData.views).toLocaleString() }}
                      </td> -->
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          Number(
                            nonskipKeywordTotal.totalImpressions
                          ).toLocaleString()
                        }}
                      </th>
                      <!-- <th>
                        {{
                          Number(bumperKeywordTotal.totalViews).toLocaleString()
                        }}
                      </th> -->
                    </tr>
                  </thead>
                </table>
              </card>
            </section>
            <div class="widget-area audience-report two-column">
              <section
                class="widget"
                v-if="
                  nonskip.audienceInteractionSeries &&
                    nonskip.audienceInteractionSeries.length > 0
                "
              >
                <h3 class="widget-title">Interacción de sus audiencias</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="nonskip.audienceInteractionChartOptions"
                    :series="nonskip.audienceInteractionSeries"
                  />
                </card>
              </section>
              <section
                class="widget"
                v-if="
                  nonskip.interestTopicsSeries &&
                    nonskip.interestTopicsSeries.length > 0
                "
              >
                <h3 class="widget-title">Interés en sus temas</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="nonskip.interestTopicsChartOptions"
                    :series="nonskip.interestTopicsSeries"
                  />
                </card>
              </section>
            </div>
            <p style="font-style: italic;">
              Se muestran los resultados de mayor volumen con un límite de 5
              elementos
            </p>

            <div class="widget-area demographic-data">
              <h3 class="widget-title">
                Datos demográficos sobre sus usuarios
              </h3>
              <section class="widget">
                <h5 class="widget-title">Género</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="nonskip.genderChartOptions.xaxis.categories"
                    :series="nonskip.genderSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Edad</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="nonskip.ageChartOptions.xaxis.categories"
                    :series="nonskip.ageSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Dispositivos</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="nonskip.devicesChartOptions.xaxis.categories"
                    :series="nonskip.devicesSeries[0].data"
                    :bar="false"
                  />
                </card>
              </section>
            </div>
            <h3 class="widget-title">
              Este es el desempeño de sus anuncios en YouTube
            </h3>
            <div class="widget-area two-column">
              <div class="widget ad-views">
                <div class="cards-wrapper">
                  <card class="ad-listing">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      indicator-position="none"
                      class="carousel-youtube"
                    >
                      <el-carousel-item
                        v-for="(nonskipAd, index) in nonskipAds"
                        :key="index"
                      >
                        <div class="youtube-header">
                          <img src="@/assets/images/youtube-logo.svg" alt />
                          <div class="header-buttons">
                            <font-awesome-icon icon="search" />
                            <!-- <font-awesome-icon icon="ellipsis-v" /> -->
                          </div>
                        </div>
                        <div class="youtube-viewport" v-if="nonskipAd.videoURL">
                          <iframe
                            width="100%"
                            height="100%"
                            :src="nonskipAd.videoURL"
                            frameborder="0"
                            scrolling="no"
                          ></iframe>
                        </div>
                        <div class="ad-data-copy">
                          <div class="data" v-if="nonskipAd.impressions">
                            <h5>
                              {{
                                Number(nonskipAd.impressions).toLocaleString()
                              }}
                            </h5>
                            <p>Impresiones</p>
                          </div>
                          <div class="data" v-if="nonskipAd.views">
                            <h5>
                              {{ Number(nonskipAd.views).toLocaleString() }}
                            </h5>
                            <p>Visualizaciones</p>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!--video for action-->
        <el-tab-pane
          v-if="isVideoforActionAvailable"
          label="Video for Action"
          name="5"
        >
          <div class="product-view youtube-product nonSkipp">
            <div>
              <section class="widget widget-goals">
                <h3 class="widget-title">
                  ¿Qué logró su publicidad en YouTube?
                </h3>
                <div class="cards-wrapper">
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="eye" />
                      </div>
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(
                            videoforaction.productData.totalImpressions
                          ) || 0
                        }}
                      </h1>
                      <p>Cantidad de veces que su anuncio fue mostrado</p>
                    </div>
                  </card>
                  <card type="goals">
                    <div class="card-header">
                      <div class="icon-wrapper">
                        <font-awesome-icon icon="mouse-pointer" />
                      </div>
                      <h4 class="card-title">Clicks</h4>
                    </div>
                    <div class="card-content">
                      <h1>
                        {{
                          numberLetter(videoforaction.TotalCampains.Clicks) || 0
                        }}
                      </h1>
                      <p>Interacciones con la audiencia</p>
                    </div>
                  </card>
                </div>
              </section>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">
                        Total de impresiones y clicks
                      </h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="Product.totalImpressions || 0"
                      :impressions="ProductVideoforAction.impressions || []"
                      :clicks="ProductVideoforAction.views || []"
                      :imp="videoforaction.impressionsChartOptions"
                      :labelType="'Visualizaciones'"
                    ></impressions>
                  </div>
                </card>
              </section>
            </div>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/youtube-phone.png" alt />
              </section>
            </mq-layout>
            <section
              class="widget campaign-widget"
              v-if="campaignVideoForActionData.length !== 0"
            >
              <h3 class="widget-title">Campañas</h3>
              <card>
                <table class="table">
                  <thead>
                    <th>Campaña</th>
                    <th>Impresiones</th>
                    <th>Views</th>
                    <th>Clicks</th>
                    <th>CPV</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(campaignVideoForActionData,
                      index) in campaignVideoForActionData"
                      :key="index"
                    >
                      <td>{{ campaignVideoForActionData.name }}</td>
                      <td>
                        {{
                          Number(
                            campaignVideoForActionData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(
                            campaignVideoForActionData.views
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        {{
                          Number(
                            campaignVideoForActionData.clicks
                          ).toLocaleString()
                        }}
                      </td>
                      <td>
                        ${{
                          Number(
                            campaignVideoForActionData.cpv
                          ).toLocaleString()
                        }}
                      </td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          videoforaction.TotalCampains.Impresiones.toLocaleString()
                        }}
                      </th>
                      <th>
                        {{
                          videoforaction.TotalCampains.Views.toLocaleString()
                        }}
                      </th>
                      <th>
                        {{
                          videoforaction.TotalCampains.Clicks.toLocaleString()
                        }}
                      </th>
                      <th>
                        ${{ videoforaction.TotalCampains.Cpv.toLocaleString() }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </card>
            </section>

            <section
              v-if="videoforaction.AllConversionActions.length"
              class="widget campaign-widget"
            >
              <h3 class="widget-title">Resumen de Conversions</h3>
              <conversion-table
                :conversionArray="videoforaction.AllConversionActions"
              />
            </section>

            <section
              class="widget keyword-widget"
              v-if="nonskipKeywordData.length"
            >
              <h3 class="widget-title">
                Keywords que mejor le ayudaron a aparecer en YouTube
              </h3>
              <card>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Keywords</th>
                      <th>Impresiones</th>
                      <!-- <th>Visualizaciones</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(videoforactionKeywordData,
                      index) in videoforactionKeywordData"
                      :key="index"
                    >
                      <td>{{ videoforactionKeywordData.keyword }}</td>
                      <td>
                        {{
                          Number(
                            videoforactionKeywordData.impressions
                          ).toLocaleString()
                        }}
                      </td>
                      <!-- <td>
                        {{ Number(bumperKeywordData.views).toLocaleString() }}
                      </td> -->
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>
                        {{
                          Number(
                            videoforactionKeywordTotal.totalImpressions
                          ).toLocaleString()
                        }}
                      </th>
                      <!-- <th>
                        {{
                          Number(bumperKeywordTotal.totalViews).toLocaleString()
                        }}
                      </th> -->
                    </tr>
                  </thead>
                </table>
              </card>
            </section>
            <div class="widget-area audience-report two-column">
              <section
                class="widget"
                v-if="
                  videoforaction.audienceInteractionSeries &&
                    videoforaction.audienceInteractionSeries.length > 0
                "
              >
                <h3 class="widget-title">Interacción de sus audiencias</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="videoforaction.audienceInteractionChartOptions"
                    :series="videoforaction.audienceInteractionSeries"
                  />
                </card>
              </section>
              <section
                class="widget"
                v-if="
                  videoforaction.interestTopicsSeries &&
                    videoforaction.interestTopicsSeries.length > 0
                "
              >
                <h3 class="widget-title">Interés en sus temas</h3>
                <card>
                  <ApexchartPie
                    type="pie"
                    width="380"
                    :options="videoforaction.interestTopicsChartOptions"
                    :series="videoforaction.interestTopicsSeries"
                  />
                </card>
              </section>
            </div>
            <p style="font-style: italic;">
              Se muestran los resultados de mayor volumen con un límite de 5
              elementos
            </p>

            <div class="widget-area demographic-data">
              <h3 class="widget-title">
                Datos demográficos sobre sus usuarios
              </h3>
              <section class="widget">
                <h5 class="widget-title">Género</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="
                      videoforaction.genderChartOptions.xaxis.categories
                    "
                    :series="videoforaction.genderSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Edad</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="videoforaction.ageChartOptions.xaxis.categories"
                    :series="videoforaction.ageSeries[0].data"
                    :bar="true"
                  />
                </card>
              </section>
              <section class="widget">
                <h5 class="widget-title">Dispositivos</h5>
                <card>
                  <ApexchartBar
                    type="bar"
                    height="350"
                    :headers="
                      videoforaction.devicesChartOptions.xaxis.categories
                    "
                    :series="videoforaction.devicesSeries[0].data"
                    :bar="false"
                  />
                </card>
              </section>
            </div>
            <h3 class="widget-title">
              Este es el desempeño de sus anuncios en YouTube
            </h3>
            <div class="widget-area two-column">
              <div class="widget ad-views">
                <div class="cards-wrapper">
                  <card class="ad-listing">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      indicator-position="none"
                      class="carousel-youtube"
                    >
                      <el-carousel-item
                        v-for="(videoforactionAd, index) in videoforactionAds"
                        :key="index"
                      >
                        <div class="youtube-header">
                          <img src="@/assets/images/youtube-logo.svg" alt />
                          <div class="header-buttons">
                            <font-awesome-icon icon="search" />
                            <!-- <font-awesome-icon icon="ellipsis-v" /> -->
                          </div>
                        </div>
                        <div
                          class="youtube-viewport"
                          v-if="videoforactionAd.videoURL"
                        >
                          <iframe
                            width="100%"
                            height="100%"
                            :src="videoforactionAd.videoURL"
                            frameborder="0"
                            scrolling="no"
                          ></iframe>
                        </div>
                        <div class="ad-data-copy">
                          <div class="data" v-if="videoforactionAd.impressions">
                            <h5>
                              {{
                                Number(
                                  videoforactionAd.impressions
                                ).toLocaleString()
                              }}
                            </h5>
                            <p>Impresiones</p>
                          </div>
                          <div
                            class="data"
                            v-if="videoforaction.productData.totalClicks"
                          >
                            <h5>
                              {{
                                Number(
                                  videoforaction.productData.totalClicks
                                ).toLocaleString()
                              }}
                            </h5>
                            <p>Clicks</p>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import Impressions from "@/components/ApexchartCustom/Impressions.vue";
import ApexchartBar from "../../components/ApexchartCustom/ApexchartBar";
import ApexchartPie from "../../components/ApexchartCustom/ApexchartPie";
import ConversionTable from "../../components/ConversionTable";
import { mapGetters } from "vuex";

// REQUEST
import adwordsYoutub from "../../services/Fase2/adwordsYoutube";
import { validateProductExpirationDate } from "../../util";

export default {
  name: "youtube",
  components: {
    ViewOptions,
    Impressions,
    ApexchartBar,
    ApexchartPie,
    ConversionTable
  },
  data() {
    return {
      activeName: "1",
      Product: { impressions: [], views: [], clicks: [] },
      loadingData: false,
      isSkipabbleAvailable: false,
      isBumperAvailable: false,
      isDiscoveryAvailable: false,
      isNonSkipAvailable: false,
      isVideoforActionAvailable: false,
      ProductBumper: { impressions: [], views: [], clicks: [] },
      ProductDiscovery: { impressions: [], views: [], clicks: [] },
      ProductNonSkip: { impressions: [], views: [], clicks: [] },
      ProductVideoforAction: { impressions: [], views: [], clicks: [] },
      skippableKeywordTotal: { totalImpressions: 0, totalViews: 0 },
      bumperKeywordTotal: { totalImpressions: 0, totalViews: 0 },
      discoveryKeywordTotal: { totalImpressions: 0, totalViews: 0 },
      nonskipKeywordTotal: { totalImpressions: 0, totalViews: 0 },
      videoforactionKeywordTotal: { totalImpressions: 0, totalViews: 0 },
      campaignData: [],

      skippable: {
        ConversionActions: [],
        AllConversionActions: [],
        productData: {
          totalImpressions: 0,
          totalViews: 0
        },
        audienceInteractionSeries: [],
        audienceInteractionChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        interestTopicsSeries: [],
        interestTopicsChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        impressionsSeries: [
          {
            name: "Impresiones",
            data: []
          },
          {
            name: "Visualizaciones",
            data: []
          }
        ],
        impressionsChartOptions: {
          tooltip: {
            x: {
              show: true,
              format: "dd MMM",
              formatter: undefined
            },

            y: {
              formatter: function(
                value
                // { series, seriesIndex, dataPointIndex, w }
              ) {
                return value.toLocaleString();
              }
            }
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ],
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 3,
            // width: [5, 7, 5],
            curve: "smooth"
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            categories: []
          },
          grid: {
            borderColor: "#f1f1f1"
          }
        },
        genderSeries: [
          {
            data: []
          }
        ],
        genderChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        ageSeries: [
          {
            data: []
          }
        ],
        ageChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        devicesSeries: [
          {
            data: []
            // 220, 160, 90, 10
          }
        ],
        devicesChartOptions: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Mobile", "Desktop", "Tablet", "TV"
          }
        },
        TotalCampains: {
          Impresiones: 0,
          Views: 0,
          Ctr: 0,
          Cpm: 0
        }
      },
      skippableAds: [],
      skippableKeywordData: [],
      bumper: {
        ConversionActions: [],
        AllConversionActions: [],
        productData: {
          totalImpressions: 0,
          totalViews: 0
        },
        audienceInteractionSeries: [],
        audienceInteractionChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        interestTopicsSeries: [],
        interestTopicsChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        impressionsSeries: [
          {
            name: "Impresiones",
            data: []
            // 100000, 321397, 245000, 445000, 857000, 683575
          }
        ],
        impressionsChartOptions: {
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ],
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 3,
            curve: "smooth"
            // curve: "straight"
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            categories: []
            // "Jun '18",
            //   "Ago '18",
            //   "Oct '18",
            //   "Dic '18",
            //   "Feb '18",
            //   "Abr '18"
          },
          grid: {
            borderColor: "#f1f1f1"
          }
          // colors: ["#3AB8FF", "#FF7B00"]
        },
        genderSeries: [
          {
            data: []
            // 150, 230
          }
        ],
        genderChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Masculino", "Femenino"
          }
        },
        ageSeries: [
          {
            data: []
            // 90, 190, 140, 100, 130
          }
        ],
        ageChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "18 - 24", "25 - 34", "35 - 44", "45 - 54", "55 ó más"
          }
        },
        devicesSeries: [
          {
            data: []
            // 220, 160, 90, 10
          }
        ],
        devicesChartOptions: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Mobile", "Desktop", "Tablet", "TV"
          }
        },
        TotalCampains: {
          Impresiones: 0,
          Clicks: 0,
          Ctr: 0,
          Cpm: 0
        }
      },
      bumperAds: [],
      bumperKeywordData: [],

      discovery: {
        ConversionActions: [],
        AllConversionActions: [],
        productData: {
          totalImpressions: 0,
          totalViews: 0
        },
        audienceInteractionSeries: [],
        audienceInteractionChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        interestTopicsSeries: [],
        interestTopicsChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        impressionsSeries: [
          {
            name: "Impresiones",
            data: []
          },
          {
            name: "Visualizaciones",
            data: []
          }
        ],
        impressionsChartOptions: {
          tooltip: {
            x: {
              show: true,
              format: "dd MMM",
              formatter: undefined
            },

            y: {
              formatter: function(
                value
                // { series, seriesIndex, dataPointIndex, w }
              ) {
                return value.toLocaleString();
              }
            }
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ],
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 3,
            // width: [5, 7, 5],
            curve: "smooth"
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            categories: []
          },
          grid: {
            borderColor: "#f1f1f1"
          }
        },
        genderSeries: [
          {
            data: []
          }
        ],
        genderChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        ageSeries: [
          {
            data: []
          }
        ],
        ageChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        devicesSeries: [
          {
            data: []
            // 220, 160, 90, 10
          }
        ],
        devicesChartOptions: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Mobile", "Desktop", "Tablet", "TV"
          }
        },
        TotalCampains: {
          Impresiones: 0,
          Clicks: 0,
          Views: 0
        }
      },
      discoveryAds: [],
      discoveryKeywordData: [],

      //NonSkip
      nonskip: {
        ConversionActions: [],
        AllConversionActions: [],
        productData: {
          totalImpressions: 0,
          totalViews: 0
        },
        audienceInteractionSeries: [],
        audienceInteractionChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        interestTopicsSeries: [],
        interestTopicsChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        impressionsSeries: [
          {
            name: "Impresiones",
            data: []
          },
          {
            name: "Visualizaciones",
            data: []
          }
        ],
        impressionsChartOptions: {
          tooltip: {
            x: {
              show: true,
              format: "dd MMM",
              formatter: undefined
            },

            y: {
              formatter: function(
                value
                // { series, seriesIndex, dataPointIndex, w }
              ) {
                return value.toLocaleString();
              }
            }
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ],
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 3,
            // width: [5, 7, 5],
            curve: "smooth"
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            categories: []
          },
          grid: {
            borderColor: "#f1f1f1"
          }
        },
        genderSeries: [
          {
            data: []
          }
        ],
        genderChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        ageSeries: [
          {
            data: []
          }
        ],
        ageChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        devicesSeries: [
          {
            data: []
            // 220, 160, 90, 10
          }
        ],
        devicesChartOptions: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Mobile", "Desktop", "Tablet", "TV"
          }
        },
        TotalCampains: {
          Impresiones: 0,
          Clicks: 0,
          Views: 0
        }
      },
      nonskipAds: [],
      nonskipKeywordData: [],

      //videoforaction
      videoforaction: {
        ConversionActions: [],
        AllConversionActions: [],
        productData: {
          totalImpressions: 0,
          totalClicks: 0
        },
        audienceInteractionSeries: [],
        audienceInteractionChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        interestTopicsSeries: [],
        interestTopicsChartOptions: {
          colors: [
            "#0A286E",
            "#0E3593",
            "#1248C9",
            "#3772FF",
            "#08ACFF",
            "#93ABE6",
            "#BECDF0"
          ],
          labels: [],
          legend: {
            position: "bottom"
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ]
        },
        impressionsSeries: [
          {
            name: "Impresiones",
            data: []
          },
          {
            name: "Clicks",
            data: []
          }
        ],
        impressionsChartOptions: {
          tooltip: {
            x: {
              show: true,
              format: "dd MMM",
              formatter: undefined
            },

            y: {
              formatter: function(
                value
                // { series, seriesIndex, dataPointIndex, w }
              ) {
                return value.toLocaleString();
              }
            }
          },
          responsive: [
            {
              breakpoint: undefined,
              options: {
                width: "100%"
              }
            }
          ],
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 3,
            // width: [5, 7, 5],
            curve: "smooth"
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6
            }
          },
          xaxis: {
            categories: []
          },
          grid: {
            borderColor: "#f1f1f1"
          }
        },
        genderSeries: [
          {
            data: []
          }
        ],
        genderChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        ageSeries: [
          {
            data: []
          }
        ],
        ageChartOptions: {
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
          }
        },
        devicesSeries: [
          {
            data: []
            // 220, 160, 90, 10
          }
        ],
        devicesChartOptions: {
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: []
            // "Mobile", "Desktop", "Tablet", "TV"
          }
        },
        TotalCampains: {
          Impresiones: 0,
          Clicks: 0,
          Views: 0,
          Cpv: 0
        }
      },
      videoforactionAds: [],
      videoforactionKeywordData: [],

      //GENRAL DATA
      DATA_API: {
        Bumper: {},
        Skipabble: {},
        Discovery: {},
        NonSkip: {},
        VideoForAction: {}
      },

      //Video Type
      VIDEO_TYPE: {
        Bumper: "1",
        Skipabble: "2",
        Discovery: "3",
        NonSkip: "4",
        VideoForAction: "5"
      }
    };
  },
  watch: {
    // date1: {
    //   handler() {
    //     this.reload(this);
    //   },
    //   deep: true
    // }

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    this.reload(context);
  },
  methods: {
    reload: async function(context) {
      this.loadingData = true;
      // RESET DATA

      //CampaignData
      context.campaignSkippableData = [];
      context.campaignBumperData = [];
      context.campaignNonSkippableData = [];
      context.campaignDiscoveryData = [];
      context.campaignVideoForActionData = [];

      // SKIPPABLE
      context.skippable.ageSeries[0].data = [];
      context.skippable.genderSeries[0].data = [];
      context.skippable.devicesSeries[0].data = [];
      context.skippableKeywordTotal = { totalImpressions: 0, totalViews: 0 };
      context.skippable.genderChartOptions.xaxis.categories = [];
      context.skippable.ageChartOptions.xaxis.categories = [];
      context.skippable.devicesChartOptions.xaxis.categories = [];
      context.skippable.TotalCampains.Impresiones = 0;
      context.skippable.TotalCampains.Views = 0;
      context.skippable.TotalCampains.Ctr = 0;
      context.skippable.TotalCampains.Cpm = 0;

      context.skippable.interestTopicsSeries = [];
      context.skippable.interestTopicsChartOptions.labels = [];
      context.skippable.audienceInteractionSeries = [];
      context.skippable.audienceInteractionChartOptions.labels = [];

      context.Product.impressions = [];
      context.Product.views = [];
      context.Product.clicks = [];

      // BUMPER
      context.bumper.ageSeries[0].data = [];
      context.bumper.genderSeries[0].data = [];
      context.bumper.devicesSeries[0].data = [];
      context.bumper.interestTopicsSeries = [];
      context.bumper.interestTopicsChartOptions.labels = [];
      context.bumper.audienceInteractionSeries = [];
      context.bumper.audienceInteractionChartOptions.labels = [];
      context.bumperKeywordTotal = { totalImpressions: 0, totalViews: 0 };

      context.bumper.productData.totalImpressions = 0;
      context.bumper.productData.totalViews = 0;
      context.ProductBumper.impressions = [];
      context.ProductBumper.views = [];
      context.ProductBumper.clicks = [];

      context.bumper.genderChartOptions.xaxis.categories = [];
      context.bumper.ageChartOptions.xaxis.categories = [];
      context.bumper.devicesChartOptions.xaxis.categories = [];
      context.bumper.TotalCampains.Impresiones = 0;
      context.bumper.TotalCampains.Clicks = 0;
      context.bumper.TotalCampains.Ctr = 0;
      context.bumper.TotalCampains.Cpm = 0;

      //DISCOVERY
      context.discovery.ageSeries[0].data = [];
      context.discovery.genderSeries[0].data = [];
      context.discovery.devicesSeries[0].data = [];
      context.discovery.interestTopicsSeries = [];
      context.discovery.interestTopicsChartOptions.labels = [];
      context.discovery.audienceInteractionSeries = [];
      context.discovery.audienceInteractionChartOptions.labels = [];
      context.discoveryKeywordTotal = { totalImpressions: 0, totalViews: 0 };

      context.discovery.genderChartOptions.xaxis.categories = [];
      context.discovery.ageChartOptions.xaxis.categories = [];
      context.discovery.devicesChartOptions.xaxis.categories = [];
      context.ProductDiscovery.impressions = [];
      context.ProductDiscovery.views = [];
      context.ProductDiscovery.clicks = [];
      context.discovery.TotalCampains.Impresiones = 0;
      context.discovery.TotalCampains.Clicks = 0;
      context.discovery.TotalCampains.Views = 0;

      //Non Skip
      context.nonskip.ageSeries[0].data = [];
      context.nonskip.genderSeries[0].data = [];
      context.nonskip.devicesSeries[0].data = [];
      context.nonskip.interestTopicsSeries = [];
      context.nonskip.interestTopicsChartOptions.labels = [];
      context.nonskip.audienceInteractionSeries = [];
      context.nonskip.audienceInteractionChartOptions.labels = [];
      context.nonskipKeywordTotal = { totalImpressions: 0, totalViews: 0 };

      context.nonskip.genderChartOptions.xaxis.categories = [];
      context.nonskip.ageChartOptions.xaxis.categories = [];
      context.nonskip.devicesChartOptions.xaxis.categories = [];
      context.ProductNonSkip.impressions = [];
      context.ProductNonSkip.views = [];
      context.ProductNonSkip.clicks = [];
      context.nonskip.TotalCampains.Impresiones = 0;
      context.nonskip.TotalCampains.Clicks = 0;
      context.nonskip.TotalCampains.Views = 0;

      //videoforaction
      context.videoforaction.productData.totalClicks = 0;
      context.videoforaction.ageSeries[0].data = [];
      context.videoforaction.genderSeries[0].data = [];
      context.videoforaction.devicesSeries[0].data = [];
      context.videoforaction.interestTopicsSeries = [];
      context.videoforaction.interestTopicsChartOptions.labels = [];
      context.videoforaction.audienceInteractionSeries = [];
      context.videoforaction.audienceInteractionChartOptions.labels = [];
      context.videoforactionKeywordTotal = {
        totalImpressions: 0,
        totalClicks: 0
      };

      context.videoforaction.genderChartOptions.xaxis.categories = [];
      context.videoforaction.ageChartOptions.xaxis.categories = [];
      context.videoforaction.devicesChartOptions.xaxis.categories = [];
      context.ProductVideoforAction.impressions = [];
      context.ProductVideoforAction.views = [];
      context.ProductVideoforAction.clicks = [];
      context.videoforaction.TotalCampains.Impresiones = 0;
      context.videoforaction.TotalCampains.Clicks = 0;
      context.videoforaction.TotalCampains.Views = 0;
      context.videoforaction.TotalCampains.Cpv = 0;

      const { businessUnitId, subscriberId, productId } = context.$route.params;
      const { customerId } = context.$route.query;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(
        products,
        productId,
        context.$store.state.subscriber.date1
      );

      let fromDate =
        context.$store.state.subscriber.date2 > validatedFinalDate
          ? validatedFinalDate
          : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      //Refactoring
      const getMetricsVideos = videoType => {
        return new adwordsYoutub(context).getMetricsVideo(
          subscriberId,
          businessUnitId,
          fromDate,
          toDate,
          customerId,
          videoType
        );
      };

      try {
        const [
          skip,
          bump,
          disco,
          noski,
          action,
        ] = await Promise.all([
          getMetricsVideos(this.VIDEO_TYPE.Skipabble),
          getMetricsVideos(this.VIDEO_TYPE.Bumper),
          getMetricsVideos(this.VIDEO_TYPE.Discovery),
          getMetricsVideos(this.VIDEO_TYPE.NonSkip),
          getMetricsVideos(this.VIDEO_TYPE.VideoForAction)
        ]);

        this.DATA_API.Skipabble = skip;
        this.DATA_API.Bumper = bump;
        this.DATA_API.Discovery = disco;
        this.DATA_API.NonSkip = noski;
        this.DATA_API.VideoForAction = action;
      } catch (e) {
        console.log("Ops! a promise failed. ", e);
      }

      this.isSkipabbleAvailable =
        this.DATA_API.Skipabble &&
        this.DATA_API.Skipabble.totalImpressions &&
        this.DATA_API.Skipabble.totalImpressions > 0;

      this.isBumperAvailable =
        this.DATA_API.Bumper &&
        this.DATA_API.Bumper.totalImpressions &&
        this.DATA_API.Bumper.totalImpressions > 0;

      this.isDiscoveryAvailable =
        this.DATA_API.Discovery &&
        this.DATA_API.Discovery.totalImpressions &&
        this.DATA_API.Discovery.totalImpressions > 0;

      this.isNonSkipAvailable =
        this.DATA_API.NonSkip &&
        this.DATA_API.NonSkip.totalImpressions &&
        this.DATA_API.NonSkip.totalImpressions > 0;

      this.isVideoforActionAvailable =
        this.DATA_API.VideoForAction &&
        this.DATA_API.VideoForAction.totalImpressions &&
        this.DATA_API.VideoForAction.totalImpressions > 0;

      this.loadingData = false;

      this.fillVideosMetrics(this.VIDEO_TYPE.Skipabble, context);
      this.fillVideosMetrics(this.VIDEO_TYPE.Bumper, context);
      this.fillVideosMetrics(this.VIDEO_TYPE.Discovery, context);
      this.fillVideosMetrics(this.VIDEO_TYPE.NonSkip, context);
      this.fillVideosMetrics(this.VIDEO_TYPE.VideoForAction, context);

      if (this.DATA_API.Skipabble) {
        this.activeName = this.VIDEO_TYPE.Skipabble;
      } else if (this.DATA_API.Bumper) {
        this.activeName = this.VIDEO_TYPE.Bumper;
      } else if (this.DATA_API.Discovery) {
        this.activeName = this.VIDEO_TYPE.Discovery;
      } else if (this.DATA_API.NonSkip) {
        this.activeName = this.VIDEO_TYPE.NonSkip;
      } else if (this.DATA_API.VideoForAction) {
        this.activeName = this.VIDEO_TYPE.VideoForAction;
      }
    },

    fillVideosMetrics(videoType, context) {
      console.log(videoType);

      let videoMetrics;
      let contextVideo;
      let contextVideoAds;
      let contextVideoKeywords;
      let objKeywords = [];
      let campaign = [];
      let contextProduct = [];
      let totalCost = 0;
      let totalClicks = 0;

      switch (videoType) {
        case this.VIDEO_TYPE.Skipabble:
          videoMetrics = this.DATA_API.Skipabble;
          contextVideo = context.skippable;
          contextVideoAds = context.skippableAds;
          contextVideoKeywords = context.skippableKeywordData;
          contextProduct = context.Product;
          context.campaignSkippableData = campaign;
          break;
        case this.VIDEO_TYPE.Bumper:
          videoMetrics = this.DATA_API.Bumper;
          contextVideo = context.bumper;
          contextVideoAds = context.bumperAds;
          contextVideoKeywords = context.bumperKeywordData;
          contextProduct = context.ProductBumper;
          context.campaignBumperData = campaign;
          break;
        case this.VIDEO_TYPE.Discovery:
          videoMetrics = this.DATA_API.Discovery;
          contextVideo = context.discovery;
          contextVideoAds = context.discoveryAds;
          contextVideoKeywords = context.discoveryKeywordData;
          contextProduct = context.ProductDiscovery;
          context.campaignDiscoveryData = campaign;
          break;
        case this.VIDEO_TYPE.NonSkip:
          videoMetrics = this.DATA_API.NonSkip;
          contextVideo = context.nonskip;
          contextVideoAds = context.nonskipAds;
          contextVideoKeywords = context.nonskipKeywordData;
          contextProduct = context.ProductNonSkip;
          context.campaignNonSkippableData = campaign;
          break;
        case this.VIDEO_TYPE.VideoForAction:
          videoMetrics = this.DATA_API.VideoForAction;
          contextVideo = context.videoforaction;
          contextVideoAds = context.videoforactionAds;
          contextVideoKeywords = context.videoforactionKeywordData;
          contextProduct = context.ProductVideoforAction;
          context.campaignVideoForActionData = campaign;
          break;
      }

      if (videoMetrics && videoMetrics.conversionActions) {
        const conversionActions = [];

        contextVideo.ConversionActions = videoMetrics.conversionActions;

        if (contextVideo.ConversionActions.length > 0) {
          contextVideo.ConversionActions.map(({ conversionActionRows }) => {
            return conversionActionRows.map(actions => {
              conversionActions.push({
                allConversion: actions.allConversion,
                conversionAction: actions.conversionAction
              });
            });
          });
        }

        contextVideo.AllConversionActions = conversionActions;
      }

      // AGES:
      (videoMetrics && videoMetrics.ages ? videoMetrics.ages : []).forEach(
        element => {
          if (element.criteria) {
            const filterCriteria = element.criteria.replace("to", " to ");
            contextVideo.ageChartOptions.xaxis.categories.push(filterCriteria);

            contextVideo.ageSeries[0].data.push(element.impressions);
          }
        }
      );

      // AUDIENCES: []
      (videoMetrics && videoMetrics.audiences
        ? videoMetrics.audiences.splice(0, 5)
        : []
      ).forEach(element => {
        contextVideo.audienceInteractionSeries.push(element.impressions);
        contextVideo.audienceInteractionChartOptions.labels.push(
          element.criteria
        );
      });

      // CAMPAIGNS: []
      if (videoMetrics) {
        videoMetrics.topics = !videoMetrics.topics
          ? null
          : videoMetrics.topics.sort((a, b) => b.impressions - a.impressions);
        videoMetrics.audiences = !videoMetrics.audiences
          ? null
          : videoMetrics.audiences.sort(
              (a, b) => b.impressions - a.impressions
            );

        // Campaign Data
        // if(videoMetrics.campaigns){
        (videoMetrics.campaigns || []).forEach(element => {
          campaign.push({
            name: element.campaignName,
            impressions: element.impressions,
            clicks: element.clicks,
            views: element.views,
            ctr: element.ctr,
            cpv: element.cpv,
            cpm: element.cpm,
            vtr: element.vtr
          });
          totalClicks += element.clicks;
          totalCost += element.cost;
        });
        // }

        // Campaign Total Data
        contextVideo.TotalCampains.Impresiones = videoMetrics.totalImpressions;
        contextVideo.TotalCampains.Views = videoMetrics.totalViews;
        contextVideo.TotalCampains.Clicks = totalClicks;
        contextVideo.TotalCampains.Cpm =
          videoMetrics.totalImpressions > 0
            ? Number(
                (totalCost / videoMetrics.totalImpressions) * 1000
              ).toFixed(2)
            : 0;
        contextVideo.TotalCampains.Ctr =
          videoMetrics.totalImpressions > 0
            ? Number(
                (totalClicks / videoMetrics.totalImpressions) * 100
              ).toFixed(2)
            : 0;
        contextVideo.TotalCampains.Cpv =
          videoMetrics.totalViews > 0
            ? Number(totalCost / videoMetrics.totalViews).toFixed(2)
            : 0;
        contextVideo.TotalCampains.Vtr =
          videoMetrics.totalViews > 0
            ? Number(
                (videoMetrics.totalViews / videoMetrics.totalImpressions) * 100
              ).toFixed(2)
            : 0;
      }

      // DEVICES: []
      (videoMetrics && videoMetrics.devices
        ? videoMetrics.devices
        : []
      ).forEach(element => {
        if (element.criteria) {
          if (element.criteria.includes("Devices")) {
            contextVideo.devicesChartOptions.xaxis.categories.push("TV");
            contextVideo.devicesSeries[0].data.push(element.impressions);
          } else {
            contextVideo.devicesChartOptions.xaxis.categories.push(
              element.criteria.split(" ")[0]
            );
            contextVideo.devicesSeries[0].data.push(element.impressions);
          }
        }
      });

      // GENDERS: []
      (videoMetrics && videoMetrics.genders
        ? videoMetrics.genders
        : []
      ).forEach(element => {
        if (element.criteria) {
          contextVideo.genderChartOptions.xaxis.categories.push(
            element.criteria
          );
          contextVideo.genderSeries[0].data.push(element.impressions);
        }
      });

      // IMPRESSIONS AND VIEWS: []  --EDITAR
      (videoMetrics && videoMetrics.impressionsAndViews
        ? videoMetrics.impressionsAndViews
        : []
      ).forEach(element => {
        contextProduct.impressions.push({
          count: element.impressions,
          date: element.date
        });
        if (contextProduct.clicks)
          contextProduct.clicks.push({
            count: element.clicks,
            date: element.date
          }) || [];
        if (contextProduct.views)
          contextProduct.views.push({
            count: element.views,
            date: element.date
          }) || [];
      });

      // KEYWORDS: [] --EDITAR
      (videoMetrics && videoMetrics.keywords
        ? videoMetrics.keywords.slice(0, 10)
        : []
      ).forEach(element => {
        objKeywords.push({
          keyword: element.criteria,
          impressions: element.impressions,
          views: element.views
        });

        contextVideoKeywords = {
          totalImpressions:
            element.impressions + contextVideoKeywords.totalImpressions,
          totalViews: element.views + contextVideoKeywords.totalViews
        };
      });

      // TOPICS: []
      (videoMetrics && videoMetrics.topics
        ? videoMetrics.topics.splice(0, 5)
        : []
      ).forEach(element => {
        contextVideo.interestTopicsSeries.push(element.impressions);
        contextVideo.interestTopicsChartOptions.labels.push(element.criteria);
      });

      // TOTAL IMPRESSIONS:
      contextVideo.productData.totalImpressions = videoMetrics
        ? videoMetrics.totalImpressions
        : 0;

      // TOTAL VIEWS:
      contextVideo.productData.totalViews = videoMetrics
        ? videoMetrics.totalViews
        : 0;

      // VIDEOS: []
      (videoMetrics && videoMetrics.videos ? videoMetrics.videos : []).forEach(
        element => {
          const obj = {
            videoURL: element.videoUrl.replace("watch?v=", "embed/"),
            impressions: element.impressions,
            views: element.views
          };

          contextVideoAds.push(obj);
        }
      );
    },
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      if (!value) {
        return 0;
      }

      let stringValue = value.toString();
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 35px;
          }
          font-size: 52px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}
.youtube-header {
  width: 100%;
  height: 45px;
  background-color: #282828;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white;
  padding: 0px 20px;
  box-sizing: border-box;
  img {
    width: 65px;
  }
  svg {
    margin-left: 10px;
  }
}
.youtube-viewport {
  width: 100%;
  height: 160px;
}

.two-column {
  display: grid;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }
  cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

.ad-data-copy {
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
  }
}

@include respond-above(sm) {
  .youtube-viewport {
    height: 200px;
  }
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .ad-data-copy {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    .data {
      border-right: 1px solid #f1f2f3;
      padding: 0px 20px;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      &:last-child {
        border-right: 0px;
      }
    }
  }
  .bumper {
    .ad-data-copy {
      grid-template-columns: 1fr;
    }
  }
}

.demographic-data {
  margin-top: 30px;
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

@include respond-above(md) {
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  }
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget {
        grid-column: 1 / -1;
      }
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .two-column {
      grid-column: 1 / -1;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
    }
  }
  .bumper {
    .widget-goals {
      .cards-wrapper {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>

<style lang="scss">
.carousel-youtube {
  .el-carousel__container {
    min-height: 350px;
  }
}

.youtube-wrapper {
  .el-tabs__nav {
    float: none;
    text-align: center;
  }
}

@include respond-above(md) {
  .carousel-youtube {
    .el-carousel__container {
      min-height: 340px;
    }
  }
  .youtube-wrapper {
    .el-tabs__item {
      padding: 0px 50px !important;
    }
  }
}

.widget.widget-goals .cards-wrapper[data-v-6449dcb4].one-column-card {
  grid-template-columns: repeat(1, 1fr) !important;
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
